<template>
    <v-container>
    <v-row justify="center" no-gutters class="mb-12">
        <v-col class="pa-0 mt-12" cols="12" md="12">
            <v-img src="../../public/img/manette.png" contain max-width="700px" class="ma-auto"></v-img>
        </v-col>
        <v-row justify="center" no-gutters>
            <v-col cols="12" md="8">
                <v-card class="ma-auto">
                    <v-card-text class="text-center"><h1 class="font-weight-bold font-weight-thin mb-4">
                        Le rendez-vous est pris du 7 au 9 février 2025</h1>
                        <h3 class="headline"><v-icon>mdi-map-marker</v-icon> Besançon</h3>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn @click="$router.push({name:'ourevent'})" text color="orange">En savoir plus</v-btn>
                        <v-btn @click="$router.push({name:'subscribe'})" text color="orange">S'inscrire</v-btn>
                        <contact-us color="orange" v-if="$vuetify.breakpoint.smAndUp"></contact-us>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-row>
    </v-container>
</template>

<script>
    import ContactUs from "./ContactUs";
    export default {
        name: "InformationDates",
        components: {ContactUs}
    }
</script>

<style scoped>

</style>